import React from "react";
export const GrayCheckMark = (React.createElement("svg", { width: "22", height: "22", viewBox: "0 0 22 22", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
    React.createElement("rect", { width: "22", height: "22", rx: "11", fill: "#283646", fillOpacity: "1" }),
    React.createElement("path", { d: "M5.61328 11.1941L6.67958 10.1059L9.4465 12.8346L15.303 7L16.3857 8.08817L9.4465 15L5.61328 11.1941Z", fill: "white" })));
